import { Div, Snack } from "@tblabs/truffle";
import { InfoFrame } from "../../../../Components/Utils/InfoFrame";
import { Order } from "../../../../Models/Order";
import { Router } from "../../../../Services/Router";
import { TimeUtils } from "../../../../Utils/TimeUtils";
import { XWarningButton } from "../../../../Components/Utils/XWarningButton";
import { Icons } from "../../../../Components/Utils/Icons";
import { OrdersManager } from "../../../../Services/OrdersManager";
import { XPrimaryButton, XSecondaryButton } from "../../../../Components/Utils/XPrimaryButton";


export class OrderHeader extends Div
{
	constructor(private _router: Router, private _manager: OrdersManager, private order: Order)
	{
		super("card card--spacing-bottom");

		this.Append(
			order.IsClosed && new InfoFrame("To zamówienie jest zamknięte", "Można je przywrócić z poziomu edycji"),

			new Div("card__content").Append(
				new Div("order-header__content").Append(
					new Div("order-header__info").Append(
						new Div("order-header__title").Text(`Zamówienie #${order.ShortId} - ${order.CurrentStep?.GetStateName() || "Zamknięte"}`),
						new Div("order-header__details").Append(
							new Div("order-header__detail").Append(
								new Div("order-header__detail-label").Text("Data utworzenia"),
								new Div("order-header__detail-value").Text(order.Meta.CreatedAt.toLocaleString()),
							),
							new Div("order-header__detail").Append(
								new Div("order-header__detail-label").Text("Ostatnia edycja"),
								new Div("order-header__detail-value").Text(TimeUtils.HowLongAgo(order.Meta.UpdatedAt, "jeszcze nigdy")),
							),
							new Div("order-header__detail").Append(
							    new Div("order-header__detail-label").Text("Status"),
							    new Div("order-header__detail-value").Text(order.Status)
							),
						),
					),
					new Div("order-header__actions").Append(
						new XPrimaryButton("Edytuj", Icons.Edit, () => _router.GoToOrderEdit(order.Id)),
						order.IsDone && new XWarningButton("Archiwizuj", Icons.Lock, async (btn) => await this.ArchiveOrder()),
						new XSecondaryButton("Widok klienta", Icons.Eye, () => _router.GoToCustomerView(order.Id)),
					)
				),
			),
		);
	}

	private async ArchiveOrder()
	{
		try
		{
			if (confirm("Czy na pewno chcesz zamknąć zamówienie? Sprawdź czy wszystkie kroki zostały wykonane i czy wszystko jest rozliczone (kasa, sprzęt etc)."))
			{
				await this._manager.Close(this.order);
				new Snack("☑️ Zamówienie zostało zamknięte");
				this._router.GoToOrdersList();
			}
		}
		catch (ex: any)
		{
			new Snack(`❌ Nie udało się zamknąć zamówienia: ${ex.message}`);
		}
	}
}
